import { Component, ContentChild, Input, TemplateRef,
    ChangeDetectionStrategy
} from '@angular/core';
import { ViewState } from '../../models/view-state.model';

@Component({
    selector: 'app-view-state-container',
    templateUrl: './view-state-container.component.html',
    styleUrls: ['./view-state-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewStateContainerComponent {

  @Input()
  state = new ViewState();

  @ContentChild('content') content: TemplateRef<any>;

}
